module.exports = __webpack_public_path__ + "static/media/TimeSaving.7df1a30c.svg";